import { render, staticRenderFns } from "./form-item-channels.vue?vue&type=template&id=940259f6&"
import script from "./form-item-channels.vue?vue&type=script&lang=js&"
export * from "./form-item-channels.vue?vue&type=script&lang=js&"
import style0 from "./form-item-channels.vue?vue&type=style&index=0&id=940259f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports